export enum HeaderScroll {
  UP = "up",
  DOWN = "down",
}

export enum MenuState {
  OPEN = "open",
  CLOSED = "closed",
}
